import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const sectionTeam = () => {
  const s = Snap('.js-slider-triangle');
  createTriangle(s, 150, 270, 75, 75, 30);
}

export default sectionTeam;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-team.js